import styled from "@emotion/styled";

export const SignInWrapper = styled.div`
  box-sizing: border-box;
  padding: 178px 0 20px;
  form {
    max-width: 500px;
  }
`;
